import _toConsumableArray from "/buddy/cc-maintainer-fe/node_modules/@babel/runtime-corejs2/helpers/toConsumableArray.js";
import "core-js/modules/es6.array.map.js";
import "core-js/modules/es6.array.find-index.js";
import { arrayToggle } from "../../../common/helpers";
import Vue from 'vue';
export function SET_MESHES(state, payload) {
  state.meshes = _toConsumableArray(payload.data);
  state.meshesMeta = payload.meta;
}
export function PUSH_MESHES(state, payload) {
  state.meshes = [].concat(_toConsumableArray(state.meshes), _toConsumableArray(payload.data));
  state.meshesMeta = payload.meta;
}
export function SELECT(state, item) {
  state.selectedMesh = item;
}
export function TOGGLE_EXPAND_MESH(state, id) {
  arrayToggle(state.expandedMeshes, id);
}
export function TOGGLE_EXPAND_CUI(state, id) {
  arrayToggle(state.expandedCuis, id);
}
export function EXPAND_ALL(state, childrenIds) {
  state.expandedMeshes = [];
  state.expandedMeshes = state.meshes.map(function (o) {
    return o.id;
  });
  state.expandedCuis = childrenIds;
}
export function COLLAPSE_ALL(state) {
  state.expandedMeshes = [];
  state.expandedCuis = [];
}
export function SET(state, payload) {
  state[payload.state] = payload.data;
}
export function UPDATE_MESH(state, _ref) {
  var data = _ref.data;
  var index = state.meshes.findIndex(function (m) {
    return m.id === data.id;
  });
  if (index >= 0) {
    Vue.set(state.meshes, index, data);
  }
}